import { render, staticRenderFns } from "./NewCustomFieldLabel.vue?vue&type=template&id=78552eee&"
import script from "./NewCustomFieldLabel.vue?vue&type=script&lang=js&"
export * from "./NewCustomFieldLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports